import { styled } from "@mui/material/styles";
import { TextField } from "@mui/material";
import treffas from "src/theme/treffas";

const TreffasTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: treffas.colors.brand.primary,
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: treffas.colors.brand.primary,
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: treffas.colors.gray[300],
    },
    "&:hover fieldset": {
      borderColor: treffas.colors.gray[800],
    },
    "&.Mui-focused fieldset": {
      borderColor: treffas.colors.brand.primary,
    },
  },
});

export default TreffasTextField;
